<template>
     <el-dialog
     title="复制工单配置"
     :visible.sync="dialogVisible"
     width="45%"
     top="10vh"
    :show-close="true"
    :modal-append-to-body="true"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    append-to-body
    @close="closeDialog"
    >
        <div style="font-size:14px;border-bottom:1px solid #aaa;height:45px;">
            <span>1.此配置为方便复制工单时，源单据的字段值是否带入新工单，用户可自行设置。</span> <br />
            <span>2.默认值：设置默认值，可提高工单复制效率</span>
        </div>
       <div class="panel">
            <!--列表-->
            <el-table
            size="small"
            :data="listData"
            highlight-current-row
            v-loading="loading"
            stripe
            border
            :header-cell-style="_headerStyle"
            element-loading-text="加载中"
            style="width: 100%;"
            >
                <el-table-column  prop="fieldName" label="工单字段">

                </el-table-column>

                <el-table-column  label="默认值" min-width="190" fixed="right">
                    <template slot-scope="scope">

                        <el-radio-group v-model="scope.row.default" v-show="scope.row.type == 0">
                            <el-radio :label="0">当前时间</el-radio>
                            <el-radio :label="1">清空</el-radio>
                        </el-radio-group>
                        <el-radio-group v-model="scope.row.default" v-show="scope.row.type == 1">
                            <el-radio :label="0">和源单据保持一致</el-radio>
                            <el-radio :label="1">清空</el-radio>
                        </el-radio-group>

                    </template>
                </el-table-column>
            </el-table>


       </div>
       <div class="panel-bottom">
            <el-button size="small" type="default"  @click="closeDialog">取消</el-button>
            <el-button size="small" type="primary"  @click="handleSave">保存</el-button>
        </div>

    </el-dialog>
</template>
<script>
export default {
    name:'copyOrderSetting',
    props:{
        diaVisible:{
            type:Boolean,
            default:false,
        },
        data:{
            type:Object,
            default:function(){
                return {};
            }
        }
    },
    watch:{
        diaVisible(newVal,oldVal){
            if(newVal){
                this.dialogVisible = newVal;
            }
        },
        data(newVal,oldVal){
            if(newVal){
            }
        }
    },
    data(){
        return{
            dialogVisible: false,
            listData:[
                {
                    id:0,
                    fieldName:"计划开始时间",
                    type:0,
                    default:0,
                },
                 {
                    id:1,
                    fieldName:"计划结束时间",
                    type:0,
                    default:0,
                },
                 {
                    id:2,
                    fieldName:"计划数",
                    type:1,
                    default:0,
                },
                 {
                    id:3,
                    fieldName:"备注",
                    type:1,
                    default:0,
                },
                 {
                    id:4,
                    fieldName:"生产任务",
                    type:1,
                    default:0,
                },
                 {
                    id:5,
                    fieldName:"车间类型",
                    type:1,
                    default:0,
                },
                 {
                    id:6,
                    fieldName:"产品图纸",
                    type:1,
                    default:0,
                },
            ],
            orderStatusList: [
                {
                    label: "自制",
                    value: "0"
                },
                {
                    label: "外购",
                    value: "1"
                },
                {
                    label: "委外",
                    value: "2"
                }
            ],
            loading:false,
        }
    },
    created(){

    },
    methods:{
        handleSave(){
            this.dialogVisible = false;
            this.$emit('save');

        },

        closeDialog(){
            setTimeout(() => {
                this.dialogVisible = false;
                this.$emit('save');
            }, 100);
        },
    }

}
</script>
<style scoped>
    .panel{
        /* width: 100%; */
        height: 350px;
        overflow-y: auto;
        overflow-x: hidden;
        margin-top: 10px;
        /* padding: 0px 50px; */
    }

    .panel-bottom{
        width: 100%;
        height: 40px;
        line-height: 40px;
        padding-top: 20px;
        text-align: center;
    }
    .panel-bottom el-button{
        margin: 10px 0 0 10px;
    }


</style>



// WEBPACK FOOTER //
// src/views/customSetting/order/copyOrderSetting.vue